/**
 * @param {PluginOptions} opts Plugin options
 * @param {Node} node
 * @return {Boolean} true if the node is a UL or OL
 */
function isList(opts, node) {
    return opts.types.includes(node.type);
}

module.exports = isList;



// WEBPACK FOOTER //
// ./src/components/slate/plugins/EditList/isList.js